import { ApiResponse } from "../../types";
import { apiClient } from "../client";
import { OpsTemplate } from "../../features/operations-management/types";

export interface UploadConfig {
  key: string;
  title: string;
  subtitle?: string;
  doc_type: string;
  extension_file: string;
  upload_title: string;
}

export interface Operation {
  ops: string;
  db_name: string;
  displayName: string;
  color: string;
  screens: string[];
  uploads: UploadConfig[];
  template_id?: number | null;
  template_name?: string | null;
}

export interface OperationsListResponse {
  operations: Operation[];
}

export interface CreateOperationRequest {
  ops: string;
  db_name: string;
  screens?: string[];
  uploads?: UploadConfig[];
  template_id?: number | null;
}

export interface UpdateOperationRequest {
  ops: string;
  db_name?: string;
  screens?: string[];
  uploads?: UploadConfig[];
  template_id?: number | null;
}

export interface CreateTemplateRequest {
  name: string;
  description?: string;
  screens?: string[];
  uploads?: UploadConfig[];
}

export interface UpdateTemplateRequest {
  id: number;
  name?: string;
  description?: string;
  screens?: string[];
  uploads?: UploadConfig[];
}

export const operationsService = {
  async listOperations(): Promise<ApiResponse<OperationsListResponse>> {
    return apiClient.get("/gestorOpsList");
  },

  async getOperation(ops: string): Promise<ApiResponse<Operation>> {
    return apiClient.post("/gestorOpsConfig", { ops });
  },

  async createOperation(
    data: CreateOperationRequest
  ): Promise<ApiResponse<{ message: string; operation: Operation }>> {
    return apiClient.post("/gestorOpsCreate", data);
  },

  async updateOperation(
    data: UpdateOperationRequest
  ): Promise<ApiResponse<{ message: string; operation: Operation }>> {
    return apiClient.put("/gestorOpsUpdate", data);
  },

  async deleteOperation(
    ops: string
  ): Promise<ApiResponse<{ message: string }>> {
    return apiClient.post("/gestorOpsDelete", { ops });
  },
};

export const templatesService = {
  async listTemplates(): Promise<ApiResponse<{ templates: OpsTemplate[] }>> {
    return apiClient.get("/gestorTemplateList");
  },

  async createTemplate(
    data: CreateTemplateRequest
  ): Promise<ApiResponse<{ template: OpsTemplate }>> {
    return apiClient.post("/gestorTemplateCreate", data);
  },

  async updateTemplate(
    data: UpdateTemplateRequest
  ): Promise<ApiResponse<{ template: OpsTemplate }>> {
    return apiClient.put("/gestorTemplateUpdate", data);
  },

  async deleteTemplate(
    id: number
  ): Promise<ApiResponse<{ message: string }>> {
    return apiClient.post("/gestorTemplateDelete", { id });
  },
};
